(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compatibility-wizard"] && !Shopify.designMode) return;
  try {
    
  function initializeKiddyViewCompatibilityWizards() {
    document.querySelectorAll('[data-compatibility-wizard]').forEach((wizard) => {
      if (wizard.dataset.initialized === 'true') return;
      wizard.dataset.initialized = 'true';
      const dialog = wizard.querySelector('.compatibility-wizard__dialog');
      const progress = wizard.querySelector('[data-wizard-progress]');
      const steps = [...wizard.querySelectorAll('[data-wizard-step]')];
      let lastTrigger;
      let cablePassed = false;
      const progressValues = { intro: 6, system: 33, cable: 67, display: 100, success: 100, 'unsupported-system': 100, 'unsupported-display': 100 };

      const showStep = (name) => {
        steps.forEach((step) => {
          const active = step.dataset.wizardStep === name;
          step.hidden = !active;
          step.classList.toggle('compatibility-wizard__step--active', active);
        });
        const activeTitle = wizard.querySelector('.compatibility-wizard__step--active .compatibility-wizard__title');
        if (activeTitle) {
          const titleId = dialog.getAttribute('aria-labelledby');
          steps.forEach((step) => step.querySelector('.compatibility-wizard__title')?.removeAttribute('id'));
          activeTitle.id = titleId;
        }
        progress.style.width = `${progressValues[name]}%`;
        dialog.scrollTop = 0;
        window.setTimeout(() => wizard.querySelector('.compatibility-wizard__step--active button, .compatibility-wizard__step--active a')?.focus({ preventScroll: true }), 30);
      };

      const setOpen = (open, trigger) => {
        if (trigger) lastTrigger = trigger;
        wizard.classList.toggle('compatibility-wizard--open', open);
        wizard.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('compatibility-wizard-open', open);
        if (open) {
          cablePassed = false;
          showStep('intro');
          window.setTimeout(() => dialog.focus(), 30);
        } else {
          lastTrigger?.focus();
        }
      };

      const bindTriggers = () => {
        document.querySelectorAll('[data-compatibility-open]').forEach((trigger) => {
          if (trigger.dataset.compatibilityBound === 'true') return;
          trigger.dataset.compatibilityBound = 'true';
          trigger.addEventListener('click', () => setOpen(true, trigger));
        });
      };

      wizard.querySelectorAll('[data-wizard-close]').forEach((button) => {
        button.addEventListener('click', () => setOpen(false));
      });
      wizard.querySelectorAll('[data-wizard-go]').forEach((button) => {
        button.addEventListener('click', () => {
          const nextStep = button.dataset.wizardGo;
          const currentStep = button.closest('[data-wizard-step]')?.dataset.wizardStep;
          if (nextStep === 'display' && currentStep === 'cable') cablePassed = true;
          if (['system', 'cable', 'unsupported-system'].includes(nextStep)) cablePassed = false;
          if (nextStep === 'success' && !cablePassed) return;
          document.dispatchEvent(new CustomEvent('kiddyview:compatibility-result', {
            detail: { passed: nextStep === 'success' && cablePassed }
          }));
          showStep(nextStep);
        });
      });

      wizard.querySelector('[data-wizard-step="success"] a')?.addEventListener('click', () => setOpen(false));

      document.addEventListener('keydown', (event) => {
        if (!wizard.classList.contains('compatibility-wizard--open')) return;
        if (event.key === 'Escape') setOpen(false);
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')].filter((element) => !element.closest('[hidden]'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      bindTriggers();
      document.addEventListener('shopify:section:load', bindTriggers);
    });
  }

  initializeKiddyViewCompatibilityWizards();
  document.addEventListener('shopify:section:load', initializeKiddyViewCompatibilityWizards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  function initializeKiddyViewHeaders(root = document) {
    root.querySelectorAll('[data-site-header]').forEach((header) => {
      if (header.dataset.initialized === 'true') return;
      header.dataset.initialized = 'true';

      const toggle = header.querySelector('[data-menu-toggle]');
      const menu = header.querySelector('[data-mobile-menu]');
      const panel = menu?.querySelector('.mobile-menu__panel');
      const closeButtons = menu?.querySelectorAll('[data-menu-close]') ?? [];
      let returnFocus = null;

      const closeLanguageMenus = (exception) => {
        header.querySelectorAll('[data-lang-switch]').forEach((switcher) => {
          if (switcher === exception) return;
          switcher.classList.remove('lang-switch--open');
          switcher.querySelector('.lang-selector')?.setAttribute('aria-expanded', 'false');
        });
      };

      const closeMenu = () => {
        if (!menu || !toggle) return;
        menu.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', toggle.dataset.openLabel);
        document.body.classList.remove('mobile-menu-open');
        returnFocus?.focus();
      };

      const openMenu = () => {
        if (!menu || !toggle) return;
        returnFocus = document.activeElement;
        menu.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', toggle.dataset.closeLabel);
        document.body.classList.add('mobile-menu-open');
        panel?.focus();
      };

      toggle?.addEventListener('click', () => {
        if (menu?.getAttribute('aria-hidden') === 'false') closeMenu();
        else openMenu();
      });
      closeButtons.forEach((button) => button.addEventListener('click', closeMenu));
      menu?.addEventListener('click', (event) => {
        if (event.target === menu) closeMenu();
      });
      menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

      header.querySelectorAll('[data-lang-switch]').forEach((switcher) => {
        const button = switcher.querySelector('.lang-selector');
        button?.addEventListener('click', () => {
          const willOpen = !switcher.classList.contains('lang-switch--open');
          closeLanguageMenus(switcher);
          switcher.classList.toggle('lang-switch--open', willOpen);
          button.setAttribute('aria-expanded', String(willOpen));
        });
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeLanguageMenus();
        else if (!event.target.closest('[data-lang-switch]')) closeLanguageMenus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeLanguageMenus();
          if (menu?.getAttribute('aria-hidden') === 'false') closeMenu();
        }
        if (event.key !== 'Tab' || menu?.getAttribute('aria-hidden') !== 'false') return;
        const focusable = [...menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  }

  initializeKiddyViewHeaders();
  document.addEventListener('shopify:section:load', (event) => initializeKiddyViewHeaders(event.target));

  } catch(e) { console.error(e); }
})();
})();
